import { render, staticRenderFns } from "./payment-type-monetaweb-paypal.vue?vue&type=template&id=0068067c"
import script from "./payment-type-monetaweb-paypal.vue?vue&type=script&lang=js"
export * from "./payment-type-monetaweb-paypal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports